// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___fpcH4","title":"style__title___3VedX","inner":"style__inner___1Ewky","icon":"style__icon___2-XZt","desc":"style__desc___2B_dJ","commentUnread":"style__commentUnread___27Bcb","commentUnreadCount":"style__commentUnreadCount___2L6h7"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/components/sticker-comments/style.css
// module id = 1265
// module chunks = 0